import { LocaleCodes } from '@flywire/internal-components/utils/translations/types';

import { DisplayMode, FormFields } from '../../../../../internal-components/src/model';
import { FieldsConfiguration } from '../../../model';
import { ENDPOINTS } from '../../endpoints';

export type checkoutUrlBuilderParams = {
  locale?: LocaleCodes;
  displayMode?: DisplayMode;
  sessionId: string;
  fields?: FieldsConfiguration;
  showDocumentCollector?: boolean;
  showAmountPanel?: boolean;
};

export const checkoutUrlBuilder = (params: checkoutUrlBuilderParams): string => {
  const {
    fields,
    sessionId,
    displayMode = 'full-screen',
    showDocumentCollector,
    showAmountPanel,
    locale
  } = params;
  let baseUrl = `${ENDPOINTS.form}?session_id=${sessionId}`;
  if (displayMode) {
    baseUrl = `${baseUrl}&display_mode=${displayMode}`;
  }

  if (locale) {
    baseUrl = `${baseUrl}&locale=${locale}`;
  }

  if (showDocumentCollector !== undefined) {
    baseUrl = `${baseUrl}&show_document_collector=${showDocumentCollector}`;
  }

  if (showAmountPanel !== undefined) {
    baseUrl = `${baseUrl}&show_amount_panel=${showAmountPanel}`;
  }

  if (!fields) {
    return baseUrl;
  }

  const fieldKeys = Object.keys(fields) as FormFields[];
  let fieldIndex = 0;
  const fieldsToUrlParams = fieldKeys.reduce((prev, curr) => {
    const normalizedKey = curr.replace(/[^a-zA-Z0-9_]/g, '');
    const fieldConfig = fields[curr];

    if (
      !normalizedKey.trim() ||
      (fieldConfig?.hidden === undefined && fieldConfig?.readOnly === undefined)
    ) {
      return prev;
    }

    let fieldParams = `&fields[${fieldIndex}][key]=${normalizedKey}`;

    if (fieldConfig?.hidden !== undefined) {
      fieldParams += `&fields[${fieldIndex}][hidden]=${fieldConfig.hidden}`;
    }
    if (fieldConfig?.readOnly !== undefined) {
      fieldParams += `&fields[${fieldIndex}][readOnly]=${fieldConfig.readOnly}`;
    }

    fieldIndex++;
    return `${prev}${fieldParams}`;
  }, '');

  return `${baseUrl}${fieldsToUrlParams}`;
};
